// ============ Hooks ============
//se puede importar en cada componente el RootState y el AppDispatch
//es mejor crear 'typed versions' del useAppDispatch & useSelector hooks para usabilidad en la aplicacion

//useSelector -> evitar tener que poner el type (state: RootState)
import {AppDispatch, RootState} from "../store/store";
import {useDispatch, useSelector} from "react-redux";
import type {TypedUseSelectorHook} from "react-redux";

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
//useDispatch -> el default type Dispatch no conoce acerca de thunks
export const useAppDispatch: () => AppDispatch = useDispatch;